// src/Components/Profile/SubscriptionPanel.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Profile.css";

export default function SubscriptionPanel({ user = {} }) {
  const navigate = useNavigate();

  // Support different possible shapes returned by various endpoints
  const hasPlan = !!(user?.plan_id || user?.subscription_id || user?.plan_name);
  const startsAt = user?.starts_at ? new Date(user.starts_at) : null;
  const endsAt = user?.ends_at ? new Date(user.ends_at) : null;

  // days left when endsAt exists, otherwise treat as 'Unlimited'
  const daysLeft = endsAt ? Math.max(0, Math.ceil((endsAt - new Date()) / 86400000)) : null;

  // friendly formatting
  const fmtRupee = (val) => {
    try {
      return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(val || 0));
    } catch {
      return `₹${val || 0}`;
    }
  };

  // show allowances if available (buyer: contacts, seller: listings)
  const contactsUnlimited = user?.contacts_unlimited === 1 || user?.contacts_unlimited === true;
  const contactsRemaining =
    typeof user?.contacts_remaining !== "undefined"
      ? Number(user.contacts_remaining)
      : typeof user?.contacts_left !== "undefined"
      ? Number(user.contacts_left)
      : null;

  const listingsAllowed =
    typeof user?.listings_allowed !== "undefined" ? user.listings_allowed : typeof user?.remaining_posts !== "undefined" ? user.remaining_posts : null;

  return (
    <section className="om-subscription">
      <h2 className="om-section-title">Active Plan</h2>

      {hasPlan ? (
        <div className="om-plan-card">
          <div className="om-plan-left">
            <h3>{user.plan_name || user.name || "Subscription"}</h3>
            <div className="om-plan-meta">
              {user.duration_days ? `${user.duration_days} days • ` : ""}
              {user.price ? fmtRupee(user.price) : (user.amount ? fmtRupee(user.amount) : "")}
            </div>

            <div style={{ marginTop: 8 }}>
              <div className="om-plan-remaining">
                {daysLeft === null ? (
                  <strong>Unlimited</strong>
                ) : (
                  <>
                    <strong>{daysLeft}</strong> day{daysLeft !== 1 ? "s" : ""} left
                  </>
                )}
              </div>

              <div className="om-plan-dates" style={{ marginTop: 6 }}>
                <small>
                  {startsAt ? `From ${startsAt.toLocaleDateString()}` : ""}
                  {endsAt ? ` — ${endsAt.toLocaleDateString()}` : daysLeft === null ? " — No expiry" : ""}
                </small>
              </div>

              {/* allowances */}
              <div style={{ marginTop: 8 }}>
                {typeof listingsAllowed !== "undefined" && listingsAllowed !== null && (
                  <div>
                    <small>Listings allowed: <strong>{listingsAllowed}</strong></small>
                  </div>
                )}

                {contactsUnlimited ? (
                  <div><small>Contacts: <strong>Unlimited</strong></small></div>
                ) : contactsRemaining !== null ? (
                  <div><small>Contacts remaining: <strong>{contactsRemaining}</strong></small></div>
                ) : null}
              </div>
            </div>
          </div>

          <div className="om-plan-actions">
            <button className="om-btn" onClick={() => navigate("/plans")}>
              Manage Plans
            </button>
          </div>
        </div>
      ) : (
        <div className="om-no-plan">
          <p>No active plan.</p>
          <button className="om-btn" onClick={() => navigate("/plans")}>
            Buy a Plan
          </button>
        </div>
      )}
    </section>
  );
}
